import { deleteSafeType } from "actions/Utilities/SafeType";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { safeTypeReFetching } from "../atoms/atoms";
import { useRecoilState } from "recoil";

export default function useDeleteSafeType() {
  const [isReFetching, setIsReFetching] = useRecoilState(safeTypeReFetching);
  const { mutate } = useMutation((ids: number[]) => deleteSafeType(ids), {
    onSuccess: (res: any) => {
      if (typeof res == "object") {
        toast.fire("Disabling Safe Type failed", res.Message, "error");
      } else {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Safe Type Disabled Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Safe Type Disabled Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Disabling Safe Type failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "Safe Type not found":
            toast.fire("Disabling Safe Type failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Disabling Safe Type failed", res, "error");
        }
      }
      setIsReFetching(isReFetching ? false : true);
    },
    onError: (error) => {
      toast.fire("Disabling Safe Type failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
}
